import { useCallback, useState, useEffect } from 'react';
import Textfield from '@mui/material/Textfield';


export default function ControlledWhenBlurredTextfield(props) {
  const {
    value: propsValue,
    onChange
  } = props;
  const [ value, setValue ] = useState(props.value);
  const [ editing, setEditing ] = useState(false);

  useEffect(() => {
    if(!editing) {
      setValue(propsValue);
    }
  }, [ editing, propsValue, setValue ]);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
  }, [ setValue ]);

  const handleFocus = useCallback((e) => {
    setEditing(true);
  }, [ setEditing ]);

  const handleBlur = useCallback((e) => {
    setEditing(false);
    onChange(e);
  }, [ setEditing, onChange ]);
  
  const handleKeyDown = useCallback((e) => {
    if(e.key === "Enter") {
      if(onChange) {
        onChange(e);
      }
    }
  }, [ onChange ]);

  return <Textfield {...props} value={value} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} onKeyDown={handleKeyDown}/>
}
